
// Placeholder script for the theme packager. Must be present and empty, but can be ignored after that.;
define("modules/common", function(){});
